import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICaseTypesService } from "services/CaseTypesService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  CaseTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const caseTypeSelectSlice = createSlice({
  name: "caseTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCaseTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCaseTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getCaseTypeSelectModels.fulfilled, (state, action) => {
        state.CaseTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getCaseTypeSelectModels = createAsyncThunk("CaseTypeSelect/GetSelectModels", async () => {
  const caseTypesService = container.get<ICaseTypesService>(SERVICE_TYPES.CaseTypesService);
  return await caseTypesService.getCaseTypeSelectModels();
});

export const selectCaseTypeSelectModels = (state: RootState) => {
  return state.caseTypesSelect.CaseTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.caseTypesSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.caseTypesSelect.LastUpdateTime;
};

export default caseTypeSelectSlice.reducer;
